module.exports = __webpack_public_path__ + "static/img/weather_storm.8d0ff45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weather_storm.png
// module id = rKzA
// module chunks = 2